import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "grid grid-cols-6" };
const _hoisted_2 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("select", {
            class: "text-center rounded-l-md rounded-r-none border-solid border-y border-gray-300 border-l font-sans font-medium text-gray-400 capitalize text-sm",
            name: "",
            id: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selected) = $event)),
            onChange: _cache[1] || (_cache[1] =
                //@ts-ignore
                (...args) => (_ctx.search && _ctx.search(...args)))
        }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchFilters, (searchFilter) => {
                return (_openBlock(), _createElementBlock("option", {
                    class: "font-medium",
                    key: searchFilter,
                    value: searchFilter
                }, _toDisplayString(searchFilter), 9, _hoisted_2));
            }), 128))
        ], 544), [
            [_vModelSelect, _ctx.selected]
        ]),
        _withDirectives(_createElementVNode("input", {
            class: "pl-4 col-span-4 border-solid border-y border-gray-300 text-gray-500 font-sans font-medium text-sm",
            type: "text",
            name: "search",
            id: "search",
            autocomplete: "off",
            placeholder: "Search...",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.content) = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(
            //@ts-ignore
            (...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
        }, null, 544), [
            [_vModelText, _ctx.content]
        ]),
        _createElementVNode("button", {
            class: "items-center inline-flex justify-center py-2 px-4 border-r border-y border-transparent rounded-r-md shadow-sm text-sm font-medium text-white bg-brand-600 hover:bg-brand-700 hover:text-brand-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:border-brand-600 focus:ring-brand-600 ease-linear duration-300",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
        }, "Search")
    ]));
}
